import '../Scss/style.scss';

import Alpine from 'alpinejs';
import AlpineI18n from 'alpinejs-i18n';
import AsyncAlpine from 'async-alpine';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { setupI18n } from './utils/i18n';
import { highlightSearchTerm } from 'highlight-search-term';

gsap.registerPlugin(ScrollTrigger);

const LG_BREAKPOINT = 992;

import ShapeBgAnimation from './gsap/ShapeBgAnimation';

import Search from './components/Search';
import NewsList from './components/NewsList';
import Accordion from './components/Accordion';
import Counter from './components/Counter';
import InfoTiles from './components/InfoTiles';
import Gallery from './components/Gallery';
import Header from './components/Header';
import IconTeasers from './components/IconTeasers';
import ImageBreak from './components/ImageBreak';
import Logowall from './components/Logowall';
// import PageHero from './components/PageHero';
import Quote from './components/Quote'; 
import TabNavigation from './components/TabNavigation';
import TeaserSlider from './components/TeaserSlider';
import ScrollTo from './components/ScrollTo';
import TeamTeasers from './components/TeamTeasers';

import 'dom-slider';
import 'bootstrap/js/dist/tab';
import SAL from './plugins/sal';
import Cookies from './plugins/cookies';
import DetectLoading from './plugins/detect-loading';
import Fancybox from './plugins/fancybox';
import LazyLoad from './plugins/lazyload';
import ScrollOffset from './plugins/scroll-offset';
import ScrollToTop from './plugins/scroll-to-top';
import VideoPlayer from './plugins/video-player';


AsyncAlpine.init(Alpine);
AsyncAlpine.start();

Alpine.data('Search', Search);
Alpine.data('NewsList', NewsList);
Alpine.data('Accordion', Accordion);
Alpine.data('Counter', Counter);
Alpine.data('InfoTiles', InfoTiles);
Alpine.data('Gallery', Gallery);
Alpine.data('Header', Header);
Alpine.data('IconTeasers', IconTeasers);
Alpine.data('ImageBreak', ImageBreak);
Alpine.data('Logowall', Logowall);
// Alpine.data('PageHero', PageHero);
Alpine.data('Quote', Quote);
Alpine.data('TabNavigation', TabNavigation);
Alpine.data('TeaserSlider', TeaserSlider);
Alpine.data('ScrollTo', ScrollTo);
Alpine.data('TeamTeasers', TeamTeasers);

Alpine.plugin(AlpineI18n);
Alpine.plugin(SAL);
Alpine.plugin(Cookies);
Alpine.plugin(DetectLoading);
Alpine.plugin(Fancybox);
Alpine.plugin(LazyLoad);
Alpine.plugin(ScrollOffset);
Alpine.plugin(ScrollToTop);
Alpine.plugin(VideoPlayer);

setupI18n();

window.Alpine = Alpine;
Alpine.start();

const initGSAP = () => {
    const initSmoothScrollAndGSAP = () => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }
  
      const gsapMM = gsap.matchMedia();

      gsapMM.add(`(min-width: ${LG_BREAKPOINT}px)`, () => {
        const cleanupMethods: (() => void)[] = [];
  
        cleanupMethods.push(ShapeBgAnimation(gsap));
  
        return () => {
          cleanupMethods.forEach(fn => {
            if (typeof fn === 'function') {
              fn();
            }
          });
        };
      });
    };
  
    initSmoothScrollAndGSAP();
  };
  
  initGSAP();

const initHashAnchorScroll = () => {
  if (!window.location.hash) {
    return;
  }

  const scrollToHash = () => {
    const target = document.querySelector<HTMLElement>(window.location.hash);

    if (!target) {
      return;
    }

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(scrollToHash, 100);
  } else {
    window.addEventListener('DOMContentLoaded', () => {
      setTimeout(scrollToHash, 100);
    });
  }
};

initHashAnchorScroll();

const initSearchHighlight = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const highlightQuery = urlParams.get('highlight');
  
  if (highlightQuery) {
    const highlightOnLoad = () => {
      try {
        highlightSearchTerm({
          search: highlightQuery,
          selector: '#main',
        });
      } catch (error) {
        console.error('Error highlighting search terms:', error);
      }
    };

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      setTimeout(highlightOnLoad, 500);
    } else {
      window.addEventListener('DOMContentLoaded', () => {
        setTimeout(highlightOnLoad, 500);
      });
    }
  }
};

initSearchHighlight();